import './ErrorPage.scss';

import { Metadata } from 'constants/error-pages/error-page-metadata';
import Button from 'design-system/Button/Button';
import Image from 'design-system/Image/Image';
import MetaData from 'design-system/MetaData/MetaData';
import { FunctionComponent } from 'react';
import PAGES from 'utils/navigation/pages';

type ErrorButtonProps = {
  name: string;
  icon?: { name: string; Component: FunctionComponent };
  isLink?: string;
  action?: () => void;
};

type ErrorPageProps = {
  title: string;
  description: string;
  button?: ErrorButtonProps;
  img: string;
  metadata?: Metadata;
};

const ErrorPage = ({ title, description, button, img, metadata }: ErrorPageProps) => {
  const linkValues = {
    contactPhone1: 'tel:+18004826910',
    contactPhone2: 'tel:+31108900070',
    imgPath: `/assets/headers/errors/${img}.svg`,
  };

  return (
    <>
      <MetaData title={metadata?.title} description={metadata?.description} />
      <section className="error-page inline-form-item align-center top col col-12">
        <div className="left">
          <h1>{title}</h1>
          <h1>{description}</h1>
          {button && (
            <Button
              content={button.name}
              icon={button.icon}
              default
              large
              className="m-t-30 no-width"
              onClick={button.action}
              isLink={button.isLink ? { external: false, href: button.isLink } : false}
            />
          )}
          <p className="m-t-80">
            <span className="label black">Do you need assistance?</span>
            <br />
            Please contact the i3D.net support team by calling <a href={linkValues.contactPhone1}>+1 800 482 6910</a>
            &nbsp;or&nbsp;
            <a href={linkValues.contactPhone2}>+31 (0)10 890 00 70</a>, or create a{' '}
            <a target="_blank" href={PAGES.ticket.create} rel="noreferrer">
              ticket
            </a>
            .
          </p>
        </div>
        <div className="right">
          <Image path={linkValues.imgPath} width="100%" height="100%" />
        </div>
      </section>
    </>
  );
};

export default ErrorPage;
